<template>
	<v-skeleton-loader
		v-if="loading"
		type="table-thead, table-tbody"
	/>
	<v-table
		v-else
		dense
	>
		<thead
			style="position: sticky; top: 50px;background-color: white; z-index: 1"
		>
			<tr>
				<th
					scope="col"
					style="width: 250px;"
				>
					<translate>
						User
					</translate>
				</th>
				<th
					v-for="role in roles"
					:key="role.id"
					scope="col"
					class="vertical-header"
				>
					<div>
						<span>
							{{ role.name }}
						</span>
					</div>
				</th>
				<th
					scope="col"
				/>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="user in users"
				:key="user.id"
			>
				<td
					class="user-cell"
					style="border-right: 1px solid #e7e7e7; font-size: small;"
				>
					<a :href="`/bo/users/view?id=${user.id}`">
						{{ fullName(user) }}
					</a>
					({{ user.email }})
				</td>
				<td
					v-for="role in roles"
					:key="role.id"
					style="padding: 0;border-right: 1px solid #e7e7e7;"
					class="text-center"
				>
					<v-icon
						v-if="user.roles.map(x => x.id).includes(role.id)"
						color="primary"
						icon="$check"
					/>
				</td>
				<td>
					<div style="padding-right: 60px" />
				</td>
			</tr>
		</tbody>
	</v-table>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'UserRoles',
	data () {
		return {
			roles: [],
			users: [],
			rolesLoading: true,
			userLoading: true,
		};
	},

	computed: {
		loading () {
			return this.rolesLoading || this.userLoading;
		}
	},

	mounted () {
		this.getRoles();
		this.getUsers();
	},

	methods: {

		/**
		 * Get all roles from the API
		 */
		getRoles () {
			axios.get('/api/v0/roles').then(({
				data
			}) => {
				this.roles = data;
			}).finally(() => {
				this.rolesLoading = false;
			});
		},

		/**
		 * Get all employees from the api
		 */
		getUsers () {
			axios.get('/api/v0/users/employees').then(({
				data
			}) => {
				this.users = data;
			}).finally(() => {
				this.userLoading = false;
			});
		},

		/**
		 * Compute users full name
		 *
		 * @param {object} user
		 * @returns {string}
		 */
		fullName (user) {
			let name = '';

			if (user.nameFirst) {
				name = name + user.nameFirst + ' ';
			} else if (user.nameInitials) {
				name = name + user.nameInitials + ' ';
			}
			if (user.nameInfix) {
				name = name + user.nameInfix + ' ' + user.nameLast;
			} else {
				name = name + ' ' + user.nameLast;
			}
			return name;
		}
	}
};
</script>

<style lang="less" scoped>
.vertical-header {
	padding: 0 !important;
	height: 85px;
	white-space: nowrap;
	> div {
		transform: rotate(315deg); /* 360 - 45 */
		width: 30px;
		margin-top: 120px;
		> span {
			padding: 10px;
		}
	}
}

.permission-cell {
	word-wrap: break-word;
	max-width: 250px;
}

.v-application--is-ltr .v-input--selection-controls__input {
	margin-right: 0;
}

.v-data-table ::v-deep.v-data-table__wrapper {
	overflow: unset;
}
</style>
